import * as NextSkyTheme from "@NextSkyTheme/global";

(function () {
  "use strict";

  const SECTION_ID = "cart-drawer";

  function updateDrawerSection(sectionsResponse) {
    if (!sectionsResponse || !sectionsResponse[SECTION_ID]) {
      console.warn("[DZ Prio] No sections data in response", sectionsResponse);
      return;
    }

    const parser = new DOMParser();
    const newDoc = parser.parseFromString(sectionsResponse[SECTION_ID], "text/html");

    const currentCartDrawer = document.querySelector("cart-drawer");
    const newCartDrawer = newDoc.querySelector("cart-drawer");

    if (!currentCartDrawer || !newCartDrawer) {
      console.warn("[DZ Prio] cart-drawer element not found", {
        currentFound: !!currentCartDrawer,
        newFound: !!newCartDrawer,
      });
      return;
    }

    currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

    // Re-instantiate the free-shipping progress bar — its JS class binds
    // to specific DOM nodes that were replaced by the innerHTML swap.
    // Without this, the "X € for free shipping" text stays stale.
    if (NextSkyTheme.FSProgressBar) {
      try {
        new NextSkyTheme.FSProgressBar("free-ship-progress-bar");
      } catch (err) {
        console.warn("[DZ Prio] FSProgressBar re-init failed:", err);
      }
    }
  }

  function bindPrioToggle(root) {
    const wrap = root.querySelector(".dz-prio");
    if (!wrap || wrap.dataset.dzPrioBound === "true") return;
    wrap.dataset.dzPrioBound = "true";

    const checkbox = wrap.querySelector(".dz-prio__checkbox");
    const variantId = wrap.dataset.prioVariantId;
    if (!checkbox || !variantId) return;

    let inFlight = false;

    function setBusy(busy) {
      inFlight = busy;
      checkbox.disabled = busy;
      wrap.toggleAttribute("aria-busy", busy);
      wrap.style.pointerEvents = busy ? "none" : "";
    }

    checkbox.addEventListener("change", async function () {
      if (inFlight) return;

      const willBeActive = checkbox.checked;
      wrap.dataset.prioActive = willBeActive ? "true" : "false";
      setBusy(true);

      try {
        let response;

        if (willBeActive) {
          response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: [SECTION_ID],
            }),
          });
          if (!response.ok) throw new Error("Add failed");
        } else {
          const cartRes = await fetch("/cart.js");
          const cart = await cartRes.json();
          const line = cart.items.find((i) => i.variant_id == variantId);
          if (line) {
            response = await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({
                id: line.key,
                quantity: 0,
                sections: [SECTION_ID],
              }),
            });
            if (!response.ok) throw new Error("Remove failed");
          }
        }

        if (response) {
          const data = await response.json();
          updateDrawerSection(data.sections);
        }

        if (NextSkyTheme.publish && NextSkyTheme.PUB_SUB_EVENTS) {
          NextSkyTheme.publish(NextSkyTheme.PUB_SUB_EVENTS.cartUpdate, {
            source: "dz-prio",
          });
        }
      } catch (err) {
        console.error("[DZ Prio Toggle] Error:", err);
        checkbox.checked = !willBeActive;
        wrap.dataset.prioActive = !willBeActive ? "true" : "false";
      } finally {
        setBusy(false);
      }
    });
  }

  function bindAll() {
    bindPrioToggle(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindAll);
  } else {
    bindAll();
  }

  if (NextSkyTheme.subscribe && NextSkyTheme.PUB_SUB_EVENTS) {
    NextSkyTheme.subscribe(NextSkyTheme.PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(bindAll, 50);
    });
  }
})();
